// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest, cryptoAvailable } from "../authConfig";

const AuthContext = createContext();

const MsalAuthProvider = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [claims, setClaims] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance
        .loginRedirect(loginRequest)
        .catch((error) => console.error("Login redirect failed:", error));
    } else if (isAuthenticated && accounts.length > 0) {
      const account = accounts[0];
      setClaims(account.idTokenClaims || {});
      setIsLoading(false);
    }
  }, [isAuthenticated, inProgress, instance, accounts]);

  const value = {
    claims,
    isAuthenticated,
    isLoading,
    user: accounts[0] || null,
    acquireToken: async (scopes = loginRequest.scopes) => {
      try {
        const response = await instance.acquireTokenSilent({
          scopes,
          account: accounts[0],
        });
        return response.accessToken;
      } catch (error) {
        console.error("Silent token acquisition failed:", error);
        await instance.acquireTokenRedirect({ scopes });
      }
    },
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const DevAuthProvider = ({ children }) => {
  const value = {
    claims: { name: "Dev User", roles: ["role.user", "role.admin", "role.risk_upload"] },
    isAuthenticated: true,
    isLoading: false,
    user: { name: "Dev User", username: "dev@localhost" },
    acquireToken: async () => null,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const AuthProvider = cryptoAvailable ? MsalAuthProvider : DevAuthProvider;

export const useAuth = () => useContext(AuthContext);
